import { Pipe, PipeTransform } from '@angular/core';
import { YearPlanningItem } from './trackline-year-planning.component';

@Pipe({
    name: 'personnelNames',
    standalone: true,
})
export class PersonnelNamesPipe implements PipeTransform {
    transform(item: YearPlanningItem): string {
        const names: string[] = [];
        if (item.planningHas.driver_user?.firstname) {
            names.push(item.planningHas.driver_user.firstname);
        }
        item.planning.user_planning?.forEach(up => {
            if (up.user?.firstname) {
                names.push(up.user.firstname);
            }
        });
        return names.join(', ');
    }
}
